/* eslint-disable import/prefer-default-export */
import {
  required, confirmed, length, email, numeric, min_value
} from 'vee-validate/dist/rules';
import {
  ValidationProvider, ValidationObserver, extend, setInteractionMode,
} from 'vee-validate';

export function installVeeValidate(Vue) {
  Vue.component('ValidationProvider', ValidationProvider);
  Vue.component('ValidationObserver', ValidationObserver);

  setInteractionMode('custom', ({ errors }) => {
    if (errors.length) {
      return {
        on: ['input', 'change'],
      };
    }
    return {
      on: ['change'],
    };
  });

  extend('required', {
    ...required,
    message: '{_field_} is required',
  });

  extend('email', {
    ...email,
    message: 'This field must be a valid email',
  });

  extend('confirmed', {
    ...confirmed,
    message: '{_field_} confirmation does not match',
  });

  extend('length', {
    ...length,
    message: '{_field_} must have 2 options',
  });

  extend('numeric', {
    ...numeric,
    message: '{_field_} only supports numbers',
  });

  extend('min_value', {
    ...min_value,
    message: 'The value must be higher than {min}',
  });
}